/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

// allow-any-unicode-comment-file
// DO NOT EDIT -- auto-generated by scripts/sync-agent-host-protocol.ts

import { ActionType } from '../common/actions.js';
import type { ResourceChange } from './state.js';

// ─── Resource Watch Actions ──────────────────────────────────────────────────

/**
 * A batch of resource changes observed by the watcher.
 *
 * Watch events are coalesced into batches by the server to keep the
 * action stream tractable; an empty `changes.items` list MUST NOT be
 * dispatched. The reducer does not retain change history — these
 * actions exist purely to deliver events to subscribers, who consume
 * them directly off the action stream and apply their own logic.
 *
 * @category Resource Watch Actions
 * @version 1
 */
export interface ResourceWatchChangedAction {
	type: ActionType.ResourceWatchChanged;
	/** The set of changes in this batch, wrapped for forward compatibility. */
	changes: { items: ResourceChange[] };
}
